import * as React from "react";

export interface EmptyScreenPlaceholderProps {
  placeholderText: string;
}

export class EmptyScreenPlaceholder extends React.Component<EmptyScreenPlaceholderProps, {}> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <div className="EmptyScreenPlaceholder__root">
        <div className="EmptyScreenPlaceholder__text">
          <p>{this.props.placeholderText}</p>
        </div>
        <div>{this.props.children}</div>
      </div>
    );
  }
}
